<template>
  <div class="w-full bg-white border-round">
    <div class="p-4 bg-f9 border-round">
      <div class="flex w-full items-start bordb pb-5">
        <div class="w-9/12 flex gap-3 items-center">
          <img
            src="@/assets/images/side.png"
            class="object-cover w-24 h-24 border-round"
            alt="banh"
          />

          <div>
            <small class="fsize10 text-6b6b6b opacity-80 font-medium"
              >Brained Studio</small
            >
            <h2 class="text-dark fsize14 font-semibold">Business Cards</h2>
            <p
              class="font-semibold fsize10 text-dark font-medium flex items-center"
            >
              Design Collabrates
            </p>
          </div>
        </div>
        <div class="w-3/12 flex justify-end">
          <p class="text-primary fsize16 font-semibold mb-0">₹1,000</p>
        </div>
      </div>
      <div class="flex justify-between items-center mt-3">
        <small class="fsize12 text-6b6b6b opacity-80 font-medium"
          >Any Details you'd like to mention?</small
        >
        <img src="@/assets/images/plus.png" alt="plusicon" class="w-6" />
      </div>
    </div>
    <div class="mt-10">
      <p class="font-semibold third-fonts">Offers & Benefits</p>

      <div class="grid grid-cols-1 gap-4 mt-3 bg-f9 px-6 py-2 border-round">
        <el-collapse>
          <el-collapse-item name="1" class="bgcollsp">
            <template slot="title">
              <p class="font-semibold text-6b6b6b bg-f9 mb-0">
                Apply Coupon Code
              </p>
            </template>
            <div class="p-2 bg-f9">
              Consistent with real life: in line with the process and logic of
              real life, and comply with languages and habits that the users are
              used to;
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="mt-8">
      <p class="font-semibold third-fonts">Bill Summary</p>

      <div class="grid grid-cols-1 gap-4 mt-3 bg-f9 py-4 px-6 border-round">
        <div class="flex justify-between items-end">
          <div>
            <small class="fsize12 text-6b6b6b opacity-80 font-medium"
              >Items Total</small
            >
            <h2 class="text-dark fsize14 font-semibold">Business Cards</h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 opacity-80 font-semibold">₹1,000</p>
          </div>
        </div>
        <div class="flex justify-between items-end">
          <div>
            <small class="fsize12 text-6b6b6b opacity-80 font-medium"
              >Promo Code</small
            >
            <h2 class="text-dark fsize14 font-semibold">BRAINED100</h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold opacity-80">-₹100</p>
          </div>
        </div>
        <div class="flex justify-between items-end bordb pb-2">
          <div>
            <small class="fsize12 text-6b6b6b opacity-80 font-medium"
              >Taxes & Charges</small
            >
            <h2 class="text-dark fsize14 font-semibold">18% GST</h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold">+₹180</p>
          </div>
        </div>
        <div class="flex justify-between items-center">
          <div>
            <h2 class="text-dark fsize14 font-semibold">Tax Amount</h2>
          </div>
          <div class="">
            <p class="col-4f fsize14 font-semibold">₹1000</p>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-between w-full mt-8 px-2 items-center">
      <div>
        <small class="col-4f fsize14 font-semibold fsize12">₹1,080</small>
        <h2 class="text-primary fsize16 font-semibold">View Bill Summary</h2>
      </div>
      <div class="">
        <vs-button
          @click="orderConfirm"
          variant="primary"
          class="rounded-full bg-primary border-0 text-white font-semibold lg:py-4 md:py-3 py-2 px-8 sm-fsize14"
        >
          Proceed to pay
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    orderConfirm() {
      this.$router.push({ name: "orderConfirm" });
    },
  },
};
</script>
